// @ts-check
import { nextArrow, prevArrow, options } from "../global/slick-options";

/**
 * @param {HTMLElement} slider
 * @param {string} size
 * @param {string} bonusOptions JSON encoded options
 */
export function slick(slider, size, bonusOptions) {
    const additionalOptions = JSON.parse(bonusOptions);

    let customOptions = {};
    let defaultOptions = {
        ...options,
        nextArrow,
        prevArrow,
    };

    if (size === "tiny") {
        customOptions = {
            ...defaultOptions,
            slidesToShow: 2,
            responsive: [
                {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 650,
                    settings: {
                        slidesToShow: 4,
                    },
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 5,
                    },
                },
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 6,
                    },
                },
            ],
        };
    } else if (size === "small") {
        customOptions = {
            ...defaultOptions,
            responsive: [
                {
                    breakpoint: 580,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 1050,
                    settings: {
                        slidesToShow: 4,
                    },
                },
            ],
        };
    } else if (size == "medium") {
        customOptions = {
            ...defaultOptions,
            responsive: [
                {
                    breakpoint: 580,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 3,
                    },
                },
            ],
        };
    } else if (size == "large") {
        customOptions = {
            ...defaultOptions,
            responsive: [
                {
                    breakpoint: 824,
                    settings: {
                        slidesToShow: 4 / 3,
                    },
                },
                {
                    breakpoint: 1050,
                    settings: {
                        slidesToShow: 2,
                    },
                },
            ],
        };
    } else if (size == "huge") {
        customOptions = {
            ...defaultOptions,
        };
    }

    jQuery(slider).slick({
        ...customOptions,
        ...additionalOptions,
    });
}

/**
 * Un-slicks the darned slider
 * @param {HTMLElement} slider
 */
export function unslick(slider) {
    jQuery(slider).slick("unslick");
}
